import RankingCard from "./RankingCard";

export default RankingCard;